import { SagaIterator } from '@redux-saga/core';
import { put } from '@redux-saga/core/effects';
import { push, RouterAction } from 'react-router-redux';
import GoToPageAction from '../actions/GoToPageAction';

export default function* goToPage(action: GoToPageAction): SagaIterator {
    yield put<RouterAction>(push(action.payload.url));
}